





















import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name      : "AuditReason",
  props: {
    width  : { type: String, default: "800px" },
    remark : { type: Boolean, default: true },
    content: { type: String, default: "" }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form   : {
        id         : "",
        op         : 0,
        result     : 0,
        remark     : "",
        description: "",
      },
    }
  },
  methods: {
    open(id: string) {
      this.$nextTick(() => {
        this.visible = true
        this.loading = false
        this.form.id = id
      })
    },
    submit() {
      this.$confirm({
        title  : "确定审核不通过？",
        content: `${this.content}`,
        onOk   : () => {
          this.$emit("submit", this.form)
        }
      })
    },
    close() {
      const form = this.$refs.form as any
      form.resetFields()
      this.loading = false
      this.visible = false
    }
  }
})

